module.exports = __webpack_public_path__ + "img/icon_paging_next.37d9bdbd.svg";